export default {
  YourPassword: 'Votre mot de passe a été modifié.',
  CanBeUsed: 'Vous pouvez l\'utiliser pour vous connecter dès maintenant.',
  Connect: 'Me connecter',
  notFound: 'Non trouvé',
};
